import { useState, useEffect } from "react";
import api from "@/lib/api";
import { StatusPill } from "@/admin/ui";
import { toast } from "sonner";
import { LogOut } from "lucide-react";

const STATUSES = ["termination_requested", "cancellation_scheduled", "offboarding_in_progress",
  "awaiting_client_acceptance", "files_ready", "transfer_completed", "service_terminated", "case_closed"];

export default function OffboardingTab({ clientId }) {
  const [terms, setTerms] = useState([]);
  const load = () => api.get(`/clients/${clientId}/terminations`).then((r) => setTerms(r.data)).catch(() => {});
  useEffect(() => { load(); }, [clientId]);

  const setStatus = (id, status) =>
    api.post(`/terminations/${id}/status`, { version: status })
      .then(() => { toast.success("Status updated"); load(); })
      .catch((e) => toast.error(e.response?.data?.detail || "Failed"));

  return (
    <div className="bg-white border border-[#E2EBF0] rounded-xl p-5" data-testid="client-offboarding">
      <div className="flex items-center gap-2 mb-3"><LogOut className="h-4 w-4 text-[#10B981]" />
        <h3 className="font-heading font-semibold text-[#0D3B2D]">Termination & handover</h3></div>
      {terms.length === 0 ? <p className="text-sm text-[#4A635A]">No termination or handover requests.</p> : (
        <ul className="space-y-2">
          {terms.map((t) => (
            <li key={t.term_id} className="flex items-center justify-between gap-3 border border-[#E2EBF0] rounded-lg px-3 py-2.5" data-testid={`term-${t.term_id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-medium text-[#0D3B2D] truncate">{t.service_name}</span>
                  <StatusPill status={t.status} />
                  {t.request_export && <span className="text-[11px] text-[#10B981]">export requested</span>}
                </div>
                {t.reason && <p className="text-[11px] text-[#4A635A] mt-0.5 truncate">“{t.reason}”</p>}
              </div>
              <select value={t.status} onChange={(e) => setStatus(t.term_id, e.target.value)}
                data-testid={`term-status-${t.term_id}`}
                className="shrink-0 text-xs bg-white border border-[#E2EBF0] rounded-lg px-2 py-1.5 text-[#0D3B2D]">
                {STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, " ")}</option>)}
              </select>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
